import React, { useEffect, useState } from 'react';
import icons from '../../icons';
import style from './ErrorSnackbar.module.css';


const ErrorSnackbar = props => {
    const [show, setShow] = useState(props.show);

    useEffect(() => {
        if (!props.show) {            
            setShow(false);
        } else {
            setShow(true);
            let timeout = setTimeout(() => {
                setShow(false);
                props.setShow(false);
            }, 3000);

            return () => clearTimeout(timeout);
        }
    }, [props.show]);

    return <main className={ style.main } style={{ height: !show && "0" }}>
        { props.loading ? <div className={ style.spinner }></div> : <img src={ props.icon ?? icons.warning_icon } className={ style.errorIcon }></img> }
        <h4 className={ style.errorMessage }>{ props.error }</h4>
    </main>;
};

export default ErrorSnackbar;